export interface FreeplayPresentation {
  readonly color: number;
}

const DEFAULT_FREEPLAY_PRESENTATION: FreeplayPresentation = Object.freeze({ color: 0xffffff });

export function defaultFreeplayPresentation(): FreeplayPresentation {
  return DEFAULT_FREEPLAY_PRESENTATION;
}

export function validateFreeplayPresentation(value: unknown): asserts value is FreeplayPresentation {
  if (!value || typeof value !== 'object' || Array.isArray(value)
    || Object.keys(value).some(key => key !== 'color')
    || !('color' in value) || typeof value.color !== 'number'
    || !Number.isSafeInteger(value.color) || value.color < 0 || value.color > 0xffffff) {
    throw new Error('Freeplay presentation color must be an RGB integer between 0x000000 and 0xFFFFFF.');
  }
}
